  (function () {
    var root = document.querySelector('[data-kh-coll]');
    if (!root) return;

    // ── Density toggle (saved per-session) ──
    var grid = root.querySelector('[data-kh-grid]');
    var densityBtns = root.querySelectorAll('[data-kh-density]');
    var savedDensity = sessionStorage.getItem('kh-coll-density') || 'cozy';
    function setDensity(d) {
      sessionStorage.setItem('kh-coll-density', d);
      densityBtns.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-kh-density') === d);
      });
      if (grid) grid.classList.toggle('kh-coll__grid--tight', d === 'tight');
    }
    densityBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { setDensity(btn.getAttribute('data-kh-density')); });
    });
    setDensity(savedDensity);

    // ── Mobile filter drawer ──
    var mq = window.matchMedia('(max-width: 1199px)');
    function isMobile() { return mq.matches; }
    var filtersAside = root.querySelector('[data-kh-filters]');
    var scrim = root.querySelector('[data-kh-scrim]');
    var filterOpenBtn = root.querySelector('[data-kh-filter-open]');
    var filterCloseBtn = root.querySelector('[data-kh-filter-close]');
    var filterApplyBtn = root.querySelector('[data-kh-filter-apply]');
    var drawerOpen = false;
    var drawerPortaled = false;
    // The filter drawer lives inside #content, deep in the page. On this theme
    // something in that subtree keeps it painting *behind* the fixed site header
    // even though its z-index (10001) far exceeds the header's — z-index alone
    // can't win across the trapping context. Moving the drawer + scrim out to a
    // top-level wrapper on <body> (outside #root) lets its fixed positioning
    // anchor to the viewport and stack above the header, so the drawer covers
    // the whole screen with its own header/✕ at the very top. The wrapper keeps
    // the .kh-coll class so the sidebar's descendant CSS still matches, and the
    // form controls carry form="kh-coll-form" so they still submit the filter
    // form now that they're no longer inside it in the DOM.
    function portalDrawer() {
      if (drawerPortaled || !filtersAside) return;
      var portal = document.createElement('div');
      portal.className = 'kh-coll';
      portal.setAttribute('data-kh-portal', '');
      if (scrim) portal.appendChild(scrim);
      portal.appendChild(filtersAside);
      document.body.appendChild(portal);
      drawerPortaled = true;
    }
    function openDrawer() {
      if (!filtersAside) return;
      if (isMobile()) portalDrawer();
      drawerOpen = true;
      filtersAside.classList.add('is-open');
      if (scrim) scrim.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      // Always open at the top: reset the drawer's scroll body on every open
      // (scroll position must not persist between openings). The header/footer
      // are fixed flex items so they're always in view; this keeps the body
      // itself at the top. The rAF pass overrides any post-open scroll the
      // browser might apply (e.g. an active checkbox scrolled into view).
      var drawerBody = filtersAside.querySelector('[data-kh-drawer-body]') || filtersAside;
      drawerBody.scrollTop = 0;
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(function () { drawerBody.scrollTop = 0; });
      }
    }
    function closeDrawer() {
      drawerOpen = false;
      if (filtersAside) filtersAside.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    if (filterOpenBtn) filterOpenBtn.addEventListener('click', openDrawer);
    if (filterCloseBtn) filterCloseBtn.addEventListener('click', closeDrawer);
    if (scrim) scrim.addEventListener('click', closeDrawer);
    if (filterApplyBtn) filterApplyBtn.addEventListener('click', function () {
      var form = document.getElementById('kh-coll-form');
      if (form) form.submit();
    });
    // Batch filtering on mobile: while the drawer is open, suppress the inline
    // per-change auto-submit (capture-phase stopPropagation reaches the input
    // before its inline handler) so users can multi-select, then tap Apply.
    if (filtersAside) {
      filtersAside.addEventListener('change', function (e) {
        if (isMobile() && drawerOpen) e.stopPropagation();
      }, true);
      filtersAside.addEventListener('blur', function (e) {
        if (isMobile() && drawerOpen) e.stopPropagation();
      }, true);
    }
    // Snap the drawer shut if the viewport grows back to desktop
    function onMqChange() { if (!mq.matches) closeDrawer(); }
    if (mq.addEventListener) mq.addEventListener('change', onMqChange);
    else if (mq.addListener) mq.addListener(onMqChange);

    // ── Mobile page-jump: navigate to ?page=N on Enter/blur ──
    var pagJump = root.querySelector('[data-kh-pag-jump]');
    if (pagJump) {
      var pagTotal = parseInt(pagJump.getAttribute('max'), 10) || 1;
      var goToPage = function () {
        var v = parseInt(pagJump.value, 10);
        if (isNaN(v) || v < 1 || v > pagTotal) return;
        var url = new URL(window.location.href);
        var cur = parseInt(url.searchParams.get('page'), 10) || 1;
        if (v === cur) return;
        url.searchParams.set('page', v);
        window.location.href = url.toString();
      };
      pagJump.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); goToPage(); }
      });
      pagJump.addEventListener('blur', goToPage);
    }

    // ── Filter <details> open/close: sync class for max-height transition ──
    root.querySelectorAll('.kh-coll__fgroup').forEach(function (det) {
      det.addEventListener('toggle', function () {
        det.classList.toggle('is-closed', !det.open);
      });
      if (!det.open) det.classList.add('is-closed');
    });

    // ── Custom sort dropdown ──
    root.querySelectorAll('[data-kh-sort]').forEach(function (sortRoot) {
      var trigger = sortRoot.querySelector('[data-kh-sort-trigger]');
      var panel = sortRoot.querySelector('[data-kh-sort-panel]');
      var label = sortRoot.querySelector('[data-kh-sort-current]');
      var hidden = document.querySelector('#kh-coll-form input[type="hidden"][name="sort_by"]');
      if (!trigger || !panel) return;

      function open() {
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }
      function close() {
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      }
      function toggle() {
        if (panel.hidden) open(); else close();
      }

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        toggle();
      });

      panel.querySelectorAll('.kh-coll__sort-opt').forEach(function (opt) {
        opt.addEventListener('click', function () {
          var v = opt.getAttribute('data-kh-sort-value');
          var l = opt.getAttribute('data-kh-sort-label') || opt.textContent.trim();
          if (hidden) hidden.value = v;
          if (label) label.textContent = l;
          panel.querySelectorAll('.kh-coll__sort-opt').forEach(function (o) {
            o.classList.remove('is-selected');
            o.setAttribute('aria-selected', 'false');
          });
          opt.classList.add('is-selected');
          opt.setAttribute('aria-selected', 'true');
          close();
          var form = document.getElementById('kh-coll-form');
          if (form) form.submit();
        });
        opt.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            opt.click();
          }
        });
      });

      // Click outside to close
      document.addEventListener('click', function (e) {
        if (!sortRoot.contains(e.target)) close();
      });
      // Escape to close
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });
    });

    // ── Price dual-handle slider ──
    root.querySelectorAll('[data-kh-price]').forEach(function (wrap) {
      var slider = wrap.querySelector('.kh-coll__price-slider');
      if (!slider) return;
      var minR = wrap.querySelector('[data-kh-price-range-min]');
      var maxR = wrap.querySelector('[data-kh-price-range-max]');
      var fill = wrap.querySelector('[data-kh-price-fill]');
      var minI = wrap.querySelector('[data-kh-price-input-min]');
      var maxI = wrap.querySelector('[data-kh-price-input-max]');
      var maxBound = parseInt(slider.getAttribute('data-kh-price-max-bound'), 10) || 1;

      function clampAndPaint() {
        var lo = parseInt(minR.value, 10) || 0;
        var hi = parseInt(maxR.value, 10) || maxBound;
        if (lo > hi - 1) lo = Math.max(0, hi - 1);
        if (hi < lo + 1) hi = Math.min(maxBound, lo + 1);
        minR.value = lo; maxR.value = hi;
        var p1 = (lo / maxBound) * 100;
        var p2 = (hi / maxBound) * 100;
        fill.style.left = p1 + '%';
        fill.style.right = (100 - p2) + '%';
        if (minI) minI.value = lo;
        if (maxI) maxI.value = hi;
      }

      function commit() {
        var form = document.getElementById('kh-coll-form');
        if (form) form.submit();
      }

      minR.addEventListener('input', clampAndPaint);
      maxR.addEventListener('input', clampAndPaint);
      minR.addEventListener('change', commit);
      maxR.addEventListener('change', commit);

      // Sync slider when user types in number inputs
      if (minI) minI.addEventListener('input', function () {
        var v = parseInt(minI.value, 10); if (!isNaN(v)) { minR.value = v; clampAndPaint(); }
      });
      if (maxI) maxI.addEventListener('input', function () {
        var v = parseInt(maxI.value, 10); if (!isNaN(v)) { maxR.value = v; clampAndPaint(); }
      });

      clampAndPaint();
    });

    // ── Track this collection's products in localStorage Recently Viewed ──
    // (We track on PDP visits, but if collection has products we don't auto-add — only PDP does.)

    // ── Render Recently Viewed rail ──
    var recentSec = root.querySelector('[data-kh-recent]');
    if (!recentSec) return;
    var recentGrid = recentSec.querySelector('[data-kh-recent-grid]');
    var recentCount = recentSec.querySelector('[data-kh-recent-count]');
    var recentClear = recentSec.querySelector('[data-kh-recent-clear]');

    function getRecent() {
      try {
        return JSON.parse(localStorage.getItem('kh-recent') || '[]');
      } catch (e) { return []; }
    }
    function renderRecent() {
      var items = getRecent().slice(0, 6);
      if (!items.length) {
        recentSec.style.display = 'none';
        return;
      }
      recentSec.style.display = '';
      recentCount.textContent = items.length;
      recentGrid.innerHTML = items.map(function (p) {
        var bg = p.bg && p.bg !== '#dde4d6' ? p.bg : '#f1ece2';
        return ''
          + '<a href="' + p.url + '" style="text-decoration:none;color:inherit;cursor:pointer;">'
          +   '<div style="aspect-ratio:1;border-radius:12px;overflow:hidden;background:' + bg + ';position:relative;">'
          +     '<div style="position:absolute;inset:0;background-image:radial-gradient(circle at center, rgba(151,115,89,0.10) 1.2px, transparent 1.6px);background-size:20px 20px;opacity:0.4;"></div>'
          +     (p.img ? '<img class="kh-product__img" src="' + p.img + '" alt="' + (p.title || '') + '" loading="lazy" style="position:absolute;inset:14%;width:72%;height:72%;object-fit:contain;">' : '')
          +   '</div>'
          +   '<div style="margin-top:12px;">'
          +     '<div style="font-family:var(--kh-mono);font-size: 11px;letter-spacing:1.4px;color:var(--kh-camel);text-transform:uppercase;">' + (p.vendor || '') + (p.type ? ' · ' + p.type : '') + '</div>'
          +     '<div style="font-family:var(--kh-serif);font-size:18px;line-height:1.15;color:var(--kh-ink);margin-top:4px;letter-spacing:-0.2px;">' + (p.title || '') + '</div>'
          +     '<div style="font-family:var(--kh-mono);font-size: 13px;letter-spacing:1px;color:var(--kh-charcoal);margin-top:4px;">' + (p.price || '') + '</div>'
          +   '</div>'
          + '</a>';
      }).join('');
    }
    if (recentClear) {
      recentClear.addEventListener('click', function () {
        localStorage.removeItem('kh-recent');
        renderRecent();
      });
    }
    renderRecent();
  })();
